import { Box, Button, TextField, Typography } from '@mui/material';
import type { QuoteDetail } from '../../../types/quote';

// BUG-2026-0120 (#4): BGC's approved 5-clause default T&C. Brand-new quotes are
// seeded with this text server-side (backend/src/constants/quoteDefaults.ts);
// this copy backs the editor's "Load Default" button. Keep the two in sync.
const DEFAULT_TERMS = `1. Total does not include applicable taxes. Disbursements are invoiced at cost plus 10%. Estimate is valid for 30 days from the date shown above.
2. The estimate assumes that the material is non-hazardous. Additional charges will apply for testing hazardous materials.
3. The testing program will be carried out under BGC's Laboratory Terms and Conditions, which must be signed and returned before the testing program can begin.
4. Samples will be kept on site for one (1) month following the issue of the final invoice, after which they will be disposed of. Additional charges will apply for samples that require special disposal methods.
5. Allowance to return the samples to the client on completion of the testing program are not included.`;

interface QuoteTermsSectionProps {
  quote: QuoteDetail;
  onUpdate: (data: Record<string, unknown>) => void;
  readOnly?: boolean;
}

export const QuoteTermsSection = ({ quote, onUpdate, readOnly }: QuoteTermsSectionProps) => {
  const handleBlur = (value: string) => {
    if (quote.Terms !== value) {
      onUpdate({ Terms: value || null });
    }
  };

  const handleLoadDefaults = () => {
    onUpdate({ Terms: DEFAULT_TERMS });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Terms &amp; Conditions
        </Typography>
        {!readOnly && (
          <Button
            variant="outlined"
            size="small"
            onClick={handleLoadDefaults}
            sx={{ textTransform: 'none', fontSize: '0.75rem' }}
          >
            Load Default
          </Button>
        )}
      </Box>

      <TextField
        label="Terms & Conditions"
        multiline
        minRows={14}
        maxRows={32}
        defaultValue={quote.Terms ?? ''}
        onBlur={(e) => handleBlur(e.target.value)}
        size="small"
        fullWidth
        disabled={readOnly}
        sx={{ maxWidth: 900 }}
        key={quote.Terms}
      />
    </Box>
  );
};
